import styled from "styled-components";

const ProductListThumbnail = styled.div`
	position: relative;

	> img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		&.img-error {
			width: 100%;
			height: auto;
		}
	}
`;

export default ProductListThumbnail;
